import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from './authentication.service';
import { Configuration } from '../../app.constants';
import { Http } from '@angular/http';


@Injectable()
export class CollectionService {
  private _collectionsUrl = this._configuration.apiUrl + "/v2/collection";

  constructor(private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }

  addCollection(collection: { name: string, supplier_id: number }): any {
    throw new Error("Method not implemented.");
  }

  removeCollection(collection_id: string): any {
    throw new Error("Method not implemented.");
  }

  getCollections(supplier_id?: number): any {
    let h = this._authService.getHeaders();
    let s = new URLSearchParams();

    if (supplier_id) s.append('supplier_id', supplier_id + '');

    return this._http.get(this._collectionsUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['collections'] == null || !Array.isArray(body['collections']))
          return [];
        return body['collections'];
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/services/collection.service.ts